<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <div class="row text-right">
          <div class="col-12">
            <button type="button" class="btn btn-primary" @click="handleInvitationModalForm">
              Einladungsschreiben hinzufügen
            </button>
          </div>
        </div>

        <div class="table-responsive overflow-auto mt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Termin</th>
              <th>Startzeit</th>
              <th>Dokument erstellt am</th>
              <th>Coach</th>
              <th>Dokument versendet am:</th>
              <th class="text-center">Aktion</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="invitation in invitationList" :key="invitation.id"
                :class="['table-row']"
                @click="handleEditInvitationModalForm(invitation.id)">
              <th>{{ invitation.termin }}</th>
              <th>{{ invitation.startTime }}</th>
              <th>{{ invitation.createdAt }}</th>
              <th>{{ invitation.coach.fullName }}</th>
              <th>{{ invitation.dateWhenItWasSentOut }}</th>
              <td class="center" style="width: 150px!important;">
                <button class="btn btn-primary mr-2"
                        @click.stop="downloadFile(
                            `/portal/group-coaching/invitation-to-first-appointment-pdf/${invitation.id}`)">
                  PDF
                </button>
                <button class="btn btn-danger ml-2" @click.stop="handleDeleteModal(invitation?.id)">
                  <i class="os-icon os-icon-trash"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Modal
          v-model="showInvitationModalForm"
          title="Einladungsschreiben"
          :hide-cancel="true"
          :button-label="$t('general.button.save')"
          sizeModal="modal-lg"
          :hide-footer="true"
          classFooter="justify-content-center">
        <Form :coachingId="coachingId"
              :invitationId="invitationId"
              :coachingStartDate="coachingData.startDate"
              :coachingEndDate="coachingData.endDate"
              v-model:submitForm="submitForm"/>
      </Modal>

      <ModalDelete
          v-model="showDeleteModal"
          :header="t('general.delete_item_header')"
          :onDelete="deleteInvitation">
      </ModalDelete>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalGroupCoachingService from '@/api/Portal/GroupCoaching';
import unemployedGroupCoachingService from '@/api/Unemployed/GroupCoaching';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { downloadFile } from '@/shared/functions';
import { piniaUserStore } from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/GroupCoaching/CoachingOverviewData.vue';
import Form from '@/views/App/Portal/GroupCoaching/InvitationToFirstAppointment/Form.vue';
import Menu from '@/views/App/Portal/GroupCoaching/Menu.vue';
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const piniaUserState          = piniaUserStore();
const piniaCurrentUser        = computed(() => piniaUserState.currentUser.user);
const { t }                   = useI18n();
const route                   = useRoute();
const coachingData            = ref('');
const invitationId            = ref('');
const invitationList          = ref([]);
const coachingId              = +route.params.id;
const isLoaded                = ref(false);
const showInvitationModalForm = ref(false);
const showDeleteModal         = ref(false);
const submitForm              = ref(false);

watch(submitForm, () => {
  showInvitationModalForm.value = false;
  showDeleteModal.value         = false;
});

async function getInvitationsList() {
  try {
    const { data }       = await portalGroupCoachingService.getInvitationsList(coachingId);
    invitationList.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getGroupCoachingData() {
  try {
    CloseToast();
    const { data } = await unemployedGroupCoachingService.getGroupCoaching(+coachingId);

    coachingData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

watch(submitForm, () => {
  invitationId.value            = null;
  showInvitationModalForm.value = false;
  showDeleteModal.value         = false;
  getGroupCoachingData();
  getInvitationsList();
});

function handleInvitationModalForm() {
  CloseToast();
  invitationId.value            = '';
  showInvitationModalForm.value = true;
  showDeleteModal.value         = false;
}

function handleEditInvitationModalForm(id) {
  CloseToast();
  invitationId.value            = id;
  showInvitationModalForm.value = true;
  showDeleteModal.value         = false;
}

function handleDeleteModal(id) {
  CloseToast();
  invitationId.value            = id;
  showDeleteModal.value         = true;
  showInvitationModalForm.value = false;
}

async function deleteInvitation() {
  try {
    await portalGroupCoachingService.invitationDelete(invitationId.value);

    invitationId.value    = null;
    showDeleteModal.value = false;

    await getGroupCoachingData();
    await getInvitationsList();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    getGroupCoachingData(),
    getInvitationsList(),
  ]);
  isLoaded.value = true;
});
</script>

<style scoped>

</style>